import PropTypes from 'prop-types';

const appealReferralDetailsPropType = PropTypes.shape({
    paActivityId: PropTypes.shape({
        label: PropTypes.string,
        medications: PropTypes.arrayOf(
            PropTypes.shape({
                data: PropTypes.shape({
                    authorizedQuantity: PropTypes.string,
                    authorizedUom: PropTypes.string,
                    ndcSpecificApproval: PropTypes.string,
                    approvedNdc: PropTypes.string,
                }),
            })
        ),
    }),
    appealDate: PropTypes.string,
    paNumber: PropTypes.string,
    followUpPhone: PropTypes.string,
    effectiveStartDate: PropTypes.string,
    effectiveEndDate: PropTypes.string,
    methodApprovalReceived: PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
    }),
    notes: PropTypes.string,
});

export default appealReferralDetailsPropType;
